import { ApiHttpClientError, ApiHttpClientErrorCode } from '../ApiHttpClient/errors/ApiClientError';
import { ApiServiceErrorCode } from '../errors/ApiServiceError';
/**
 *
 * @type {Readonly<{}>}
 */
export const ApiHttpClientToApiServiceCodeMap = Object.freeze({
    [ApiHttpClientError.Code.INTERNAL]: ApiServiceErrorCode.INTERNAL,
    [ApiHttpClientError.Code.BAD_REQUEST]: ApiServiceErrorCode.INTERNAL,
    [ApiHttpClientError.Code.FORBIDDEN]: ApiServiceErrorCode.FORBIDDEN,
    [ApiHttpClientError.Code.NOT_FOUND]: ApiServiceErrorCode.NOT_FOUND,
    [ApiHttpClientError.Code.UNAUTHORIZED]: ApiServiceErrorCode.UNAUTHORIZED,
    [ApiHttpClientError.Code.INTERNAL_SERVER_ERROR]: ApiServiceErrorCode.INTERNAL,
    [ApiHttpClientError.Code.CONFLICT]: ApiServiceErrorCode.CONFLICT
});
